const scrollTo = (id: string) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Footer() {
  return (
    <footer className="bg-brand-black text-white font-sans">
      {/* Top Section */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="lg:col-span-1">
          <img
            src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/c46a838d2525f8cd633ba5d324174d96.png"
            alt="Bertochi e Lemes Advogados"
            className="h-16 w-auto object-contain mb-4"
          />
          <p className="text-white/60 text-sm leading-relaxed mb-6">
            Especialistas em Direito Trabalhista com foco em acidente de trabalho e doença ocupacional. Atendimento humanizado e estratégico.
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://www.instagram.com/bertochielemes.adv"
              target="_blank"
              rel="nofollow noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full border border-brand-gold/40 text-brand-gold hover:bg-brand-gold hover:text-brand-black transition-all duration-300 cursor-pointer"
            >
              <i className="ri-instagram-line text-base" />
            </a>
            <a
              href="https://wa.me/5511984095840"
              target="_blank"
              rel="nofollow noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full border border-brand-gold/40 text-brand-gold hover:bg-brand-gold hover:text-brand-black transition-all duration-300 cursor-pointer"
            >
              <i className="ri-whatsapp-line text-base" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-brand-gold text-sm font-semibold tracking-widest uppercase mb-6">
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}>Links Rápidos</a>
          </h4>
          <ul className="space-y-3">
            {[
              { label: 'Início', id: 'hero' },
              { label: 'Áreas de Atuação', id: 'areas' },
              { label: 'Sobre o Escritório', id: 'sobre' },
              { label: 'Como Funciona', id: 'como-funciona' },
              { label: 'Fale Conosco', id: 'cta' },
            ].map((link) => (
              <li key={link.id}>
                <button
                  onClick={() => scrollTo(link.id)}
                  className="text-white/60 hover:text-brand-gold text-sm transition-colors duration-300 cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Areas */}
        <div>
          <h4 className="text-brand-gold text-sm font-semibold tracking-widest uppercase mb-6">
            <a href="#areas" onClick={(e) => { e.preventDefault(); scrollTo('areas'); }}>Áreas de Atuação</a>
          </h4>
          <ul className="space-y-3">
            {[
              'Acidente de Trabalho',
              'Doença Ocupacional',
              'Burnout e Depressão',
              'LER / DORT',
              'Reintegração e Estabilidade',
            ].map((area) => (
              <li key={area}>
                <span className="text-white/60 text-sm">{area}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-brand-gold text-sm font-semibold tracking-widest uppercase mb-6">Contato</h4>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-whatsapp-line text-brand-gold text-base" />
              </div>
              <div>
                <p className="text-white/60 text-xs mb-0.5">WhatsApp</p>
                <a href="https://wa.me/5511984095840" target="_blank" rel="nofollow noreferrer" className="text-white text-sm hover:text-brand-gold transition-colors duration-300 cursor-pointer">
                  11 98409-5840
                </a>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-instagram-line text-brand-gold text-base" />
              </div>
              <div>
                <p className="text-white/60 text-xs mb-0.5">Instagram</p>
                <a href="https://www.instagram.com/bertochielemes.adv" target="_blank" rel="nofollow noreferrer" className="text-white text-sm hover:text-brand-gold transition-colors duration-300 cursor-pointer">
                  @bertochielemes.adv
                </a>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-time-line text-brand-gold text-base" />
              </div>
              <div>
                <p className="text-white/60 text-xs mb-0.5">Horário de Atendimento</p>
                <p className="text-white text-sm">Seg–Sex: 09h às 18h</p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-map-pin-line text-brand-gold text-base" />
              </div>
              <div>
                <p className="text-white/60 text-xs mb-0.5">Região de Atuação</p>
                <p className="text-white text-sm">SP Capital, ABC Paulista e Campinas</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-brand-gold/20">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs text-center sm:text-left">
            © 2026 Bertochi e Lemes Sociedade de Advogados. Todos os direitos reservados. OAB/SP.
          </p>
          <p className="text-white/40 text-xs text-center sm:text-right">
            Desenvolvido por{' '}
            <a
              href="https://startdigital1.com.br"
              target="_blank"
              rel="nofollow noreferrer"
              className="text-brand-gold hover:underline transition-all duration-300 cursor-pointer"
            >
              Start Digital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
